// extracted by mini-css-extract-plugin
export var carrierIcon = "_v4-0";
export var carrierLogo = "_v4-1";
export var detailsSection = "_v4-2";